module.exports = __webpack_public_path__ + "img/senior_service_4.2bd83dfa.png";